// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/payments/salary-advances",
  Detail: "/pyr/payments/salary-advances/{id}",
  DetailEmployee: "/pyr/payments/salary-advances/{id}/details",
  ListShort: "/pyr/payments/salary-advances/short",
  Create: "/pyr/payments/salary-advances",
  Update: "/pyr/payments/salary-advances",
  ApprovalStatus: "/pyr/payments/salary-advances/approval-status",
  BankTransfer: "/pyr/payments/salary-advances/bank-transfer",
};
